
import {
    navigator_getRunIn_fe,
    navigator_watchPosition_clear_f,
    navigator_watchPosition_start_f
} from "./S_Navigator";
import {
    android_geoLocationListener_set_f,
    android_geoLocationListener_stop_f,
    android_getBatteryLevel_f,
    android_getVersion_f,
    android_loginWithProvider_f,
    android_logout_f,
    android_notification_chat,
    android_qrScanner_f,
    android_setKeyboardOnChangeListener_f,
    android_takeImage_f,
    android_takeVideo_f,
    android_takeVideo_finish_f
} from "./S_AndroidApp";
import {enum_eventsListenersNames, enum_loginMethods, enum_runIn_es} from "../../functions/src/shareCode/Share_S_Enum";
import {
    ios_geoLocationListener_set_f, ios_geoLocationListener_stop_f,
    ios_getBatteryLevel_f, ios_getVersion,
    ios_loginWithProvider_f,
    ios_logMe_f,
    ios_logout_f,
    ios_notification_chat, ios_qrScanner_f, ios_setKeyboardOnChangeListener_f, ios_takeImage_f,
    ios_takeVideo_f
} from "./S_IosApp";
import {eventListener_addEventListenerToObj, eventListener_removeEventListenerToObj} from "./S_EventListeners";
import {route_moveToWindow_f} from "../router";
import {gv_urls} from "./S_GlobalVar";
import {store_getStateValue_vo, store_setStateValue, store_var} from "../store";
import {
    serverAuth_currentUserLangCode_update_f, serverAuth_login_facebook_fp,
    serverAuth_login_google_fp,
    serverAuth_logout_fp
} from "./Server/S_ServerAuth";
import {google_signIn_fp} from "@/scripts/API/S_API_Google";
import {facebook_login_fp} from "@/scripts/API/S_API_Facebook";
import {flutter_logMe_f, flutter_takeImage_f} from "@/scripts/S_Flutter";
import {FB_AndroidInfo, FB_UserGeoLocation} from "../../functions/src/shareCode/Share_S_Classes";
import {obj_forEach_f, obj_size_fn} from "../../functions/src/shareCode/Share_S_Obj";

// let runIn_e = store_getStateValue(store_var.system_runIn_e).val
//
// switch (runIn_e){
//
//     // WEB
//     case enum_runIn_es.ios_web_chrome:
//     case enum_runIn_es.ios_web_safari:
//     case enum_runIn_es.ios_web_other:
//     case enum_runIn_es.ios_pwa_safari:
//     case enum_runIn_es.android_pwa_chrome:
//     case enum_runIn_es.android_web_chrome:
//     case enum_runIn_es.android_web_other:
//     case enum_runIn_es.other:
//     case enum_runIn_es.mac_other:
//     case enum_runIn_es.mac_chrome:
//     case enum_runIn_es.mac_safari:
//     case enum_runIn_es.windows_other:
//     case enum_runIn_es.windows_chrome:
//         break;
//
//     // ANDROID
//     case enum_runIn_es.android_app:
//         break;
//
//     // IOS
//     case enum_runIn_es.ios_app:
//         break;
// }

// appWebManager_init_f
export const appWebManager_init_f = () => {

    let runIn_e = navigator_getRunIn_fe()
    store_setStateValue(store_var.system_runIn_e, runIn_e)

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            break;

        // ANDROID
        case enum_runIn_es.android_app:

            break;

        // IOS
        case enum_runIn_es.flutter_app:
            console.log = (message) => {
                flutter_logMe_f(message)
            }

            break;
        case enum_runIn_es.ios_app:
            console.log = (message) => {
                ios_logMe_f(JSON.stringify(message))
            }
            break;
    }
}

// webAppManager_geoLocationListener
let geoLocationCb_byId_f = {}
export const webAppManager_geoLocationListener_set_f = (id_n, cb_f) => {

    if(obj_size_fn(geoLocationCb_byId_f) > 0){
        geoLocationCb_byId_f[id_n] = cb_f
        return
    }
    geoLocationCb_byId_f[id_n] = cb_f

    const runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:


            navigator_watchPosition_start_f((position) => {

                if(position == null){
                    return
                }

                let userGeoLocation_c = new FB_UserGeoLocation({
                    ugl_userId_uid          : null,
                    _ugl_accuracy_n         : position.coords.accuracy,
                    ugl_altitude_n          : position.coords.altitude,
                    ugl_altitudeAccuracy_n  : position.coords.altitudeAccuracy,
                    ugl_heading_n           : position.coords.heading,
                    ugl_latitude_n          : position.coords.latitude,
                    ugl_longitude_n         : position.coords.longitude,
                    ugl_speed_n             : position.coords.speed,
                    ugl_timestamp_t         : position.timestamp
                })

                obj_forEach_f(geoLocationCb_byId_f, cb_f => cb_f(userGeoLocation_c))

                cb_f(userGeoLocation_c)
            })

            break;

        // ANDROID
        case enum_runIn_es.android_app:
            android_geoLocationListener_set_f((location_o) =>{

                let userGeoLocation_c = new FB_UserGeoLocation({
                    ugl_userId_uid          : null,
                    _ugl_accuracy_n         : location_o.accuracy,
                    ugl_altitude_n          : 0,
                    ugl_altitudeAccuracy_n  : 0,
                    ugl_heading_n           : location_o.heading,
                    ugl_latitude_n          : location_o.lat,
                    ugl_longitude_n         : location_o.lng,
                    ugl_speed_n             : location_o.speed,
                    ugl_timestamp_t         : location_o.timestamp
                })

                obj_forEach_f(geoLocationCb_byId_f, cb_f => cb_f(userGeoLocation_c))

            })
            break;

        // IOS
        case enum_runIn_es.ios_app:
            ios_geoLocationListener_set_f( (location_o) => {
                let userGeoLocation_c = new FB_UserGeoLocation({
                    ugl_userId_uid          : null,
                    _ugl_accuracy_n         : location_o.accuracy,
                    ugl_altitude_n          : 0,
                    ugl_altitudeAccuracy_n  : 0,
                    ugl_heading_n           : location_o.heading,
                    ugl_latitude_n          : location_o.lat,
                    ugl_longitude_n         : location_o.lng,
                    ugl_speed_n             : location_o.speed,
                    ugl_timestamp_t         : location_o.timestamp
                })
                obj_forEach_f(geoLocationCb_byId_f, cb_f => cb_f(userGeoLocation_c))
            })
            break;
    }



}
export const webAppManager_geoLocationListener_stop_f = (id_n) => {

    delete geoLocationCb_byId_f[id_n]
    if(obj_size_fn(geoLocationCb_byId_f) > 0){
        return
    }

    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            navigator_watchPosition_clear_f()

            break;

        // ANDROID
        case enum_runIn_es.android_app:
            android_geoLocationListener_stop_f()

            break;

        // IOS
        case enum_runIn_es.ios_app:
            ios_geoLocationListener_stop_f()

            break;
    }

}

// webAppManager_getBatteryLevel_f
export const webAppManager_getBatteryLevel_f = (cb_f) => {

    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            cb_f(-1)
            break;

        // ANDROID
        case enum_runIn_es.android_app:
            android_getBatteryLevel_f(cb_f)
            break;

        // IOS
        case enum_runIn_es.ios_app:
            ios_getBatteryLevel_f(cb_f)
            break;
    }

}

// webAppManager_captureVideo_f
export const webAppManager_captureVideo_f = (cb_f) => {

    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            let inputVideo = document.createElement("INPUT");
            inputVideo.setAttribute("type", "file");
            inputVideo.setAttribute("accept", "video/*");
            inputVideo.setAttribute("maxlength", "12");
            inputVideo.click()
            eventListener_addEventListenerToObj(inputVideo, enum_eventsListenersNames.change, false, "inputVideo", (e) => {
                eventListener_removeEventListenerToObj(inputVideo, enum_eventsListenersNames.change, "inputVideo");
                cb_f(e.target.files[0])
            })
            break;

        // ANDROID
        case enum_runIn_es.android_app:
            handleFileTransport_cb_f(android_takeVideo_f, cb_f, "video/mp4", android_takeVideo_finish_f)

            break;

        // IOS
        case enum_runIn_es.ios_app:
            handleFileTransport_cb_f(ios_takeVideo_f, cb_f, "video/mp4")

            break;
    }

}

// webAppManager_captureImage_f
export const webAppManager_captureImage_f = (cb_f) => {


    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            let inputImage = document.createElement("INPUT");
            inputImage.setAttribute("type", "file");
            inputImage.setAttribute("accept", "image/*");
            // inputImage.setAttribute("capture", "true");
            inputImage.click()
            eventListener_addEventListenerToObj(inputImage, enum_eventsListenersNames.change, false, "inputImage", (e) => {
                eventListener_removeEventListenerToObj(inputImage, enum_eventsListenersNames.change, "inputImage");
                cb_f(e.target.files[0])
            })

            break;

        // ANDROID
        case enum_runIn_es.flutter_app:
            flutter_takeImage_f()
            break;

        case enum_runIn_es.android_app:
            handleFileTransport_cb_f(android_takeImage_f, cb_f, "image/jpeg")
            break;

        // IOS
        case enum_runIn_es.ios_app:
            handleFileTransport_cb_f(ios_takeImage_f, cb_f, "image/jpeg")
            break;
    }

}

// webAppManager_logout_f
export const webAppManager_logout_f = (cb_f) => {


    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            serverAuth_logout_fp(cb_f)

            break;

        // ANDROID
        case enum_runIn_es.android_app:
            android_logout_f(() => {
                serverAuth_logout_fp(cb_f)
            })
            break;

        // IOS
        case enum_runIn_es.ios_app:
            ios_logout_f()
            serverAuth_logout_fp(cb_f)
            break;
    }

}

// webAppManager_loginWithProvider_f
export const webAppManager_getProviderToken_fp = (provider_e) => {

    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // ANDROID
        case enum_runIn_es.android_app:
            return new Promise((resolve) => {
                android_loginWithProvider_f(provider_e, (idToken_s) =>{
                    resolve(idToken_s)
                })
            })

        // IOS
        case enum_runIn_es.ios_app:
            return new Promise((resolve) => {
                ios_loginWithProvider_f(provider_e, (idToken_s) =>{
                    resolve(idToken_s)
                })
            })

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
        default:
            switch(provider_e){
                case enum_loginMethods.google:
                    return google_signIn_fp()
                case enum_loginMethods.facebook:
                    return facebook_login_fp()
            }

    }

}

// webAppManager_notification_f
export const webAppManager_notification_f = (title, content) => {


    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            break;

        // ANDROID
        case enum_runIn_es.android_app:
            android_notification_chat(title, content)
            break;

        // IOS
        case enum_runIn_es.ios_app:
            ios_notification_chat(title, content)
            break;
    }

}

// webAppManager_setKeyboardOnChangeListener_f
export const webAppManager_setKeyboardOnChangeListener_f = (cb_f) => {

    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            break;

        // ANDROID
        case enum_runIn_es.android_app:
            android_setKeyboardOnChangeListener_f(cb_f)
            break;

        // IOS
        case enum_runIn_es.ios_app:
            ios_setKeyboardOnChangeListener_f(cb_f)
            break;
    }
}

// webAppManager_getVersion_f
export const webAppManager_getVersion_f = (cb_f) => {


    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            cb_f(null, null)
            break;

        // ANDROID
        case enum_runIn_es.android_app:
            android_getVersion_f((androidInfo_o) => {
                let androidInfo_c = new FB_AndroidInfo(JSON.parse(androidInfo_o))
                cb_f(androidInfo_c, null)
            })
            break;

        // IOS
        case enum_runIn_es.ios_app:
            ios_getVersion((iosVersion_s) => {
                cb_f(null, iosVersion_s)
            })
            break;
    }
}

// webAppManager_startUpdate_f
export const webAppManager_startUpdate_f = (cb_f) => {

    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            cb_f(null, null)
            break;

        // ANDROID
        case enum_runIn_es.android_app:
            route_moveToWindow_f(gv_urls.googleStore);
            break;

        // IOS
        case enum_runIn_es.ios_app:
            route_moveToWindow_f(gv_urls.appStore);
            break;
    }
}

// webAppManager_do
export const  webAppManager_clickInput_f = (e) => {

    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val
    // console.log("focus")

    switch (runIn_e){

        // pc
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            break;

        // WEB mobile
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:

        // applications
        case enum_runIn_es.android_app:
        case enum_runIn_es.ios_app:

            // date_setTimeout(() => {
            //     e.srcElement.scrollIntoView()
            // }, 500, "appWebManager")

            break;
    }

}

// webAppManager_qrScanner_f
export const webAppManager_qrScanner_f = (cb_f) => {

    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val


    switch (runIn_e){

        // WEB phone
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
            store_setStateValue(store_var.ongoing_qrScannerCb_f, (value) => {
                store_setStateValue(store_var.ongoing_qrScannerCb_f, null);
                cb_f(value)
            })
            break;

        // web pc
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            store_setStateValue(store_var.ongoing_qrScannerCb_f, cb_f)
            break;

        // ANDROID
        case enum_runIn_es.android_app:
            android_qrScanner_f(cb_f)
            break;

        case enum_runIn_es.ios_app:
            ios_qrScanner_f(cb_f)
            break;

    }

}

// webAppManager_runInNativeApp_fb
export const webAppManager_runInNativeApp_fb = () => {

    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            return false

        // ANDROID
        case enum_runIn_es.android_app:
        case enum_runIn_es.ios_app:
            return true
    }

}

// webAppManager_runInIosWeb_fb
export const webAppManager_runInIosWeb_fb = () => {

    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
            return true

        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:

        case enum_runIn_es.android_app:
        case enum_runIn_es.ios_app:
            return false
    }

}

// webAppManager_runInMobile_fb
export const webAppManager_runInMobile_fb = () => {

    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){


        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
        case enum_runIn_es.other:
            return false

        // WEB
        case enum_runIn_es.ios_web_other:
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.android_pwa_chrome:
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:


        case enum_runIn_es.android_app:
        case enum_runIn_es.ios_app:
            return true
    }

}

// appWebManager_getTopBarNativeApp_n
export const appWebManager_getTopBarNativeApp_n = () => {
    let runIn_e = store_getStateValue_vo(store_var.system_runIn_e).val

    switch (runIn_e){

        // WEB
        case enum_runIn_es.ios_web_chrome:
        case enum_runIn_es.ios_web_safari:
        case enum_runIn_es.ios_web_other:
            return 80;
        case enum_runIn_es.ios_pwa_safari:
        case enum_runIn_es.android_pwa_chrome:
            return 0;
        case enum_runIn_es.android_web_chrome:
        case enum_runIn_es.android_web_other:
            return 55;

        case enum_runIn_es.other:
        case enum_runIn_es.mac_other:
        case enum_runIn_es.mac_chrome:
        case enum_runIn_es.mac_safari:
        case enum_runIn_es.windows_other:
        case enum_runIn_es.windows_chrome:
            return 0

        // ANDROID
        case enum_runIn_es.android_app:
            return 10

        // IOS
        case enum_runIn_es.ios_app:
            return 20


    }

    return 0

}

// =========== private functions ===============

// handleFileTransport_cb_f
const handleFileTransport_cb_f = (calledFunction_f, cb_f, fileType, cbAppWhenFinish_f) => {

    let bytesArrFinal_an = [];
    calledFunction_f((msg) =>{
        // last call
        if(msg === "finish"){

            let blob = new Blob(bytesArrFinal_an,{type : fileType})
            console.log("blobSize=" + blob.size)
            cb_f(blob)
            if(cbAppWhenFinish_f != null){cbAppWhenFinish_f()}

            return
        }

        // add bytes to final array
        let bytesArr_an = b64toByteArr(msg)
        bytesArrFinal_an = bytesArrFinal_an.concat(bytesArr_an);
    })
}

// b64toByteArr
const b64toByteArr = (b64Data, contentType='', sliceSize=512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return byteArrays

}